<template>
  <div class="select-time-2">
    <div class="select-time-2__main-slot">
      <slot />
    </div>

    <!-- Нет интервалов для замены -->
    <div
      v-if="isDisabledEvening && isDisabledMorning"
      class="select-time-2__message"
    >
      <div class="select-time-2__message-item">
        {{ getNoIntervalsTextObject.text }}
      </div>
      <div class="select-time-2__message-item">
        {{ getNoIntervalsTextObject.time }}
      </div>
    </div>
    <!-- !Нет интервалов для замены -->

    <!-- Доступны утренние интервалы для замены -->
    <div
      v-if="!isDisabledMorning"
      class="select-time-2__time-container"
    >
      <!-- Доступен только один вариант утренней доставки -->
      <div
        v-if="isDisabledEvening && getMorningTimeIntervals.length === 1"
        class="select-time-2__message"
      >
        <div class="select-time-2__message-item">
          {{ getNoIntervalsTextObject.text }}
        </div>
        <div class="select-time-2__message-item">
          {{ getNoIntervalsTextObject.time }}
        </div>
      </div>
      <!-- !Доступен только один вариант утренней доставки -->

      <!-- Доступно несколько вариантов утренней доставки -->
      <template v-else>
        <div class="select-time-2__food-date">
          <span class="select-time-2__food-date-type">Утро</span>&nbsp;
          <span class="select-time-2__food-date-date">({{ getMorningFoodDate }})</span>
        </div>
        <div
          class="select-time-2__select-time-container"
        >
          <div
            v-for="(interval, intervalIndex) in getMorningTimeIntervals"
            :key="`interval-index-${intervalIndex}`"
            class="select-time-2__select-time-item"
          >
            <div
              class="select-time-2__select-time-button"
              :class="{
                'selected': isCurrentTimeInterval(`${interval.from}-${interval.to}`)
              }"
              @click="selectTimeInterval({from: interval.from, to: interval.to, type: 'morning'})"
            >
              {{ interval.from }}-{{ interval.to }}
            </div>
          </div>
        </div>
      </template>
      <!-- !Доступно несколько вариантов утренней доставки -->
    </div>
    <!-- !Доступны утренние интервалы для замены -->

    <div
      v-if="!isDisabledEvening && !isDisabledMorning"
      class="select-time-2__separator"
    />

    <!-- Доступны вечерние интервалы для замены -->
    <div
      v-if="!isDisabledEvening"
      class="select-time-2__time-container"
    >
      <!-- Доступен только один вариант вечерней доставки -->
      <div
        v-if="isDisabledMorning && getEveningTimeIntervals.length === 1"
        class="select-time-2__message"
      >
        <div class="select-time-2__message-item">
          {{ getNoIntervalsTextObject.text }}
        </div>
        <div class="select-time-2__message-item strong">
          {{ getNoIntervalsTextObject.time }}
        </div>
      </div>
      <!-- !Доступен только один вариант вечерней доставки -->

      <!-- Доступно несколько вариантов вечерней доставки -->
      <template v-else>
        <div class="select-time-2__food-date">
          <span class="select-time-2__food-date-type">Вечер</span>&nbsp;
          <span class="select-time-2__food-date-date">({{ getEveningFoodDate }})</span>
        </div>
        <div
          class="select-time-2__select-time-container"
        >
          <div
            v-for="(interval, intervalIndex) in getEveningTimeIntervals"
            :key="`interval-index-${intervalIndex}`"
            class="select-time-2__select-time-item"
          >
            <div
              class="select-time-2__select-time-button"
              :class="{
                'selected': isCurrentTimeInterval(`${interval.from}-${interval.to}`),
                'no-active': !canChangeTime && !isCurrentTimeInterval(`${interval.from}-${interval.to}`),
              }"
              @click="selectTimeInterval({from: interval.from, to: interval.to, type: 'evening'})"
            >
              {{ interval.from }}-{{ interval.to }}
            </div>
          </div>
        </div>
      </template>
      <!-- !Доступно несколько вариантов вечерней доставки -->
    </div>
    <!-- !Доступны вечерние интервалы для замены -->
  </div>
</template>

<script>
import { inject } from 'vue'
import { foodDates } from '@/services/foodDates'

export default {
  name: 'SelectTime2',

  props: {
    /**
     * @description блокировка возможности смены даты
     */
    canChangeTime: {
      type: Boolean,
      default: true,
    },

    delivery: {
      type: Object,
      required: true,
    },

    timeIntervals: {
      type: Object,
      required: false,
      default () {
        return {}
      },
    },

    newDeliveryDate: {
      type: Object,
      default () {
        return {}
      },
    },

    currentDeliveryDate: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  emits: [
    'selectNewTimeInterval',
    'autoSelectNewTimeInterval',
  ],

  setup () {
    const config = inject('config')

    return {
      config,
    }
  },

  data () {
    return {
      dayIntervalType: 'morning',
      from: '',
      to: '',
    }
  },

  computed: {
    isDisabledEvening () {
      return this.dayIntervalType === 'none' || !this.getEveningTimeIntervals.length
    },

    isDisabledMorning () {
      return this.dayIntervalType === 'none' || !this.getMorningTimeIntervals.length
    },

    getEveningTimeIntervals () {
      if (!Object.prototype.hasOwnProperty.call(this.timeIntervals, 'evening')) {
        return []
      }

      const {
        evening = [],
      } = this.timeIntervals

      return evening
    },

    numberOfDaysInDelivery () {
      return this.config?.numberOfDaysInDelivery
      // return 2
    },

    getMorningTimeIntervals () {
      if (!Object.prototype.hasOwnProperty.call(this.timeIntervals, 'morning')) {
        return []
      }

      const {
        morning = [],
      } = this.timeIntervals

      return morning
    },

    getMorningFoodDate () {
      const {
        date = null,
      } = this.newDeliveryDate
      const {
        morning = [],
      } = this.timeIntervals
      const {
        evening: evening2 = [],
      } = this.timeIntervalsPlusDay
      const first = morning.length > 0 ? this.$date(date).format('D') : ''
      const second = evening2.length > 0 ? this.$date(date).add(this.numberOfDaysInDelivery - 1, 'day').format('D') : ''
      return foodDates({ first, second })
    },

    getEveningFoodDate () {
      const {
        date = null,
      } = this.newDeliveryDate

      const {
        morning = [],
      } = this.timeIntervalsPlusDay
      const {
        evening: evening2 = [],
      } = this.timeIntervalsPlusDayDay

      const first = morning.length > 0 ? this.$date(date).add(1, 'day').format('D') : ''
      const second = evening2.length > 0 ? this.$date(date).add(this.numberOfDaysInDelivery, 'day').format('D') : ''

      return foodDates({ first, second })
    },

    getCurrentTimeIntervals () {
      return this.timeIntervals[this.dayIntervalType]
    },

    getNoIntervalsTextObject () {
      if (!this.delivery) {
        return ''
      }

      if (!this.delivery.isSessionEditable) {
        let text = `На ${this.$date(this.newDeliveryDate.date).format('D MMM')} доступна только `
        text += `${this.newDeliveryDate.type === 'evening' ? 'вечерняя' : 'утренняя'} доставка с `

        let time = `${this.newDeliveryDate.timeFrom || (this.newDeliveryDate.type === 'evening' ? '18:00' : '07:00')} `
        time += `до ${this.newDeliveryDate.timeTo || (this.newDeliveryDate.type === 'evening' ? '23:00' : '12:00')}`

        return {
          text,
          time,
        }
      } else {
        const {
          morning = [],
          evening = [],
        } = this.timeIntervals

        let text = ''
        let time = ''

        if (morning.length > 0 || evening.length > 0) {
          text = `На ${this.$date(this.newDeliveryDate.date).format('D MMM')} доступна только `
          if (morning.length > 0) {
            text += 'утренняя доставка с '
            time = `${morning[0].from} до ${morning[0].to}`
          } else if (evening.length > 0) {
            text += 'вечерняя доставка с '
            time = `${evening[0].from} до ${evening[0].to}`
          }
        }

        return {
          text,
          time,
        }
      }
    },
  },

  watch: {
    'timeIntervals' () {
      this.setDayInterval()
      this.setTimeInterval()
      this.selectTimeInterval({
        from: this.from,
        to: this.to,
      }, true)
    },
  },

  mounted () {
    this.setDayInterval()
    this.setTimeInterval()
    this.selectTimeInterval({
      from: this.from,
      to: this.to,
    }, true)
  },

  methods: {
    selectDayInterval (value) {
      if (this.hasDayInterval(value)) {
        this.dayIntervalType = value
      }
    },

    selectTimeInterval (value, isAuto = false) {
      if (!this.canChangeTime) {
        return
      }

      const {
        from = '',
        to = '',
        type = '',
      } = value

      this.from = from
      this.to = to
      this.dayIntervalType = type

      this.$emit(
        isAuto
          ? 'autoSelectNewTimeInterval'
          : 'selectNewTimeInterval'
        , {
          from: this.from,
          to: this.to,
          type: this.dayIntervalType,
        })
    },

    hasDayInterval (value) {
      return Object.prototype.hasOwnProperty.call(this.timeIntervals, value)
    },

    setDayInterval () {
      if (this.currentDeliveryDate.type) {
        const {
          type = '',
        } = this.currentDeliveryDate

        this.dayIntervalType = type
      } else if (!Object.prototype.hasOwnProperty.call(this.timeIntervals, this.dayIntervalType)) {
        if (Object.prototype.hasOwnProperty.call(this.timeIntervals, 'morning')) {
          this.dayIntervalType = 'morning'
        } else if (Object.prototype.hasOwnProperty.call(this.timeIntervals, 'evening')) {
          this.dayIntervalType = 'evening'
        } else {
          this.dayIntervalType = 'none'
        }
      }
    },

    setTimeInterval () {
      if (
        this.currentDeliveryDate.timeTo &&
        this.currentDeliveryDate.timeFrom
      ) {
        const {
          timeFrom = '',
          timeTo = '',
        } = this.currentDeliveryDate

        this.from = timeFrom
        this.to = timeTo
      } else if (this.dayIntervalType !== 'none') {
        if (this.timeIntervals[this.dayIntervalType].length > 0) {
          const {
            from = '',
            to = '',
          } = this.timeIntervals[this.dayIntervalType][0]

          this.from = from
          this.to = to
        }
      }
    },

    isCurrentTimeInterval (value) {
      return value === `${this.from}-${this.to}`
    },
  },
}
</script>

<style lang="scss">
$prefix: 'select-time-2';

.#{$prefix} {
  width: 100%;
  padding: 0 0.24rem;
}

.#{$prefix}__time-container {
  // margin-bottom: 0.24rem;
}

.#{$prefix}__food-date {
  margin-bottom: 0.16rem;
}

.#{$prefix}__food-date-type {
  @include typography('b3', 'bold');
  color: map-get($colors, 'gray_60');
}

.#{$prefix}__food-date-date {
  @include typography('b3', 'medium');
  color: map-get($colors, 'gray_60');
}

.#{$prefix}__separator {
  width: 100%;
  height: 1px;

  margin: 0.24rem 0 0.16rem 0;

  background: map-get($colors, 'gray_eb');
}

.#{$prefix}__main-slot {
  margin-bottom: 0.12rem;
}

.#{$prefix}__toggle {
  @include row;

  margin: 0 0.68rem 0.24rem 0.68rem;

  background: map-get($colors, 'grey_4');

  border-radius: 18px;
}

.#{$prefix}__col {
  @include columns(2, 1);
}

.#{$prefix}__toggle-button {
  @include typography('b2', 'bold');

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;

  padding: 0.06rem 0;
  margin: 2px;

  color: map-get($colors, 'gray_60');

  border-radius: 18px;

  cursor: pointer;

  &:hover {
    color: map-get($colors, 'black');
  }

  &.disabled {
    color: map-get($colors, 'grey_20');
  }

  &.selected {
    background: map-get($colors, 'white');
    color: map-get($colors, 'default');
  }
}

.#{$prefix}__lock {
  margin-left: 0.07rem;

  width: 0.12rem;
  height: 0.12rem;

  color: map-get($colors, 'default');
}

.#{$prefix}__select-time-container {
  @include row;
  @include margin-x(-0.02rem);
  @include margin-y(-0.02rem);
}

.#{$prefix}__select-time-item {
  @include columns(3, 1);
}

.#{$prefix}__select-time-button {
  @include typography('b3', 'medium');
  text-align: center;

  margin: 0.02rem;
  padding: 0.07rem 0;

  color: map-get($colors, 'gray_60');
  background: map-get($colors, 'white');

  cursor: pointer;

  border: 1px solid map-get($colors, 'gray_eb');
  border-radius: 4px;

  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;

  &:hover {
    color: map-get($colors, 'black');

    border: 1px solid map-get($colors, 'grey_20');
  }

  &.selected {
    background: map-get($colors, 'green_5');
    color: map-get($colors, 'default');

    border: 1px solid map-get($colors, 'default');
    border-radius: 4px;

    box-sizing: border-box;
    box-shadow: 0 2px 4px rgba(68, 195, 115, 0.05);
  }

  &.no-active {
    cursor: not-allowed;

    background: map-get($colors, 'grey_1');
    border: 1px solid map-get($colors, 'grey_4');
    color: map-get($colors, 'grey_20');
  }
}

.#{$prefix}__message {
  @include typography('b3', 'medium');
  color: map-get($colors, 'grey_60');
}
.#{$prefix}__message-item {
  display: inline-block;
  margin-right: 0.02rem;

  &.strong {
    @include typography('b3', 'bold');
    color: map-get($colors, 'black');
  }
}
</style>
